/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Desc_Move_Word_To_Next_EventInputs */

const en_shortcut_keys_desc_move_word_to_next_event = /** @type {(inputs: Shortcut_Keys_Desc_Move_Word_To_Next_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shift a single word forward to the beginning of the next Event`)
};

const fr_shortcut_keys_desc_move_word_to_next_event = /** @type {(inputs: Shortcut_Keys_Desc_Move_Word_To_Next_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deplacer un mot vers le debut de l'evenement suivant`)
};

const de_shortcut_keys_desc_move_word_to_next_event = /** @type {(inputs: Shortcut_Keys_Desc_Move_Word_To_Next_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verschiebe ein einzelnes Wort an den Anfang des nächsten Ereignisses.`)
};

const it_shortcut_keys_desc_move_word_to_next_event = /** @type {(inputs: Shortcut_Keys_Desc_Move_Word_To_Next_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sposta una singola parola in avanti all'inizio del prossimo evento`)
};

const ru_shortcut_keys_desc_move_word_to_next_event = /** @type {(inputs: Shortcut_Keys_Desc_Move_Word_To_Next_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Переместите одно слово вперед, в начало следующего события.`)
};

const es_shortcut_keys_desc_move_word_to_next_event = /** @type {(inputs: Shortcut_Keys_Desc_Move_Word_To_Next_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desplazar una sola palabra hacia adelante hasta el comienzo del siguiente evento`)
};

const zh_cn2_shortcut_keys_desc_move_word_to_next_event = /** @type {(inputs: Shortcut_Keys_Desc_Move_Word_To_Next_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`将一个词向前移动一个位置，放到下一个事件的开头。`)
};

const ja_shortcut_keys_desc_move_word_to_next_event = /** @type {(inputs: Shortcut_Keys_Desc_Move_Word_To_Next_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`次のイベントの先頭まで単語を1つ進めます`)
};

const hi_shortcut_keys_desc_move_word_to_next_event = /** @type {(inputs: Shortcut_Keys_Desc_Move_Word_To_Next_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अगले इवेंट की शुरुआत में जाने के लिए एक शब्द आगे खिसकाएँ।`)
};

const pt_pt2_shortcut_keys_desc_move_word_to_next_event = /** @type {(inputs: Shortcut_Keys_Desc_Move_Word_To_Next_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desloque uma única palavra para o início do próximo evento.`)
};

/**
* | output |
* | --- |
* | "Shift a single word forward to the beginning of the next Event" |
*
* @param {Shortcut_Keys_Desc_Move_Word_To_Next_EventInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_desc_move_word_to_next_event = /** @type {((inputs?: Shortcut_Keys_Desc_Move_Word_To_Next_EventInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Desc_Move_Word_To_Next_EventInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_shortcut_keys_desc_move_word_to_next_event(inputs)
	if (locale === "de") return de_shortcut_keys_desc_move_word_to_next_event(inputs)
	if (locale === "it") return it_shortcut_keys_desc_move_word_to_next_event(inputs)
	if (locale === "ru") return ru_shortcut_keys_desc_move_word_to_next_event(inputs)
	if (locale === "es") return es_shortcut_keys_desc_move_word_to_next_event(inputs)
	if (locale === "zh-CN") return zh_cn2_shortcut_keys_desc_move_word_to_next_event(inputs)
	if (locale === "ja") return ja_shortcut_keys_desc_move_word_to_next_event(inputs)
	if (locale === "hi") return hi_shortcut_keys_desc_move_word_to_next_event(inputs)
	if (locale === "pt-PT") return pt_pt2_shortcut_keys_desc_move_word_to_next_event(inputs)
	return en_shortcut_keys_desc_move_word_to_next_event(inputs)
});